import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import styles from './NeighbourhoodsListSkeleton.module.scss';
const skeletonArr = Array.from({
  length: 6
});
const NeighbourhoodsListSkeleton = () => {
  return <Box className={styles['neighbourhoods-list-skeleton-container']} data-sentry-element="Box" data-sentry-component="NeighbourhoodsListSkeleton" data-sentry-source-file="NeighbourhoodsListSkeleton.tsx">
      {skeletonArr.map((item, index) => <Box key={'NEIGHBOURHOODS_ITEM_' + index} className={styles['neighbourhoods-item-skeleton']}>
          <Skeleton width={25} height={25} variant="rounded" />
          <Skeleton width={100} height={20} />
        </Box>)}
    </Box>;
};
export default NeighbourhoodsListSkeleton;